import * as Sentry from '@sentry/vue'

/** Breadcrumbs for OTA debugging; in Sentry Issues open Breadcrumbs and filter category `player_apk_ota`. */
export function addPlayerApkOtaSentryBreadcrumb(payload: Record<string, unknown>): void {
  try {
    const phase = typeof payload.phase === 'string' ? payload.phase : 'event'
    Sentry.addBreadcrumb({
      category: 'player_apk_ota',
      message: phase,
      level: payload.phase === 'download_or_install_failed' ? 'error' : 'info',
      data: payload
    })
  }
  catch {
    /* Sentry not initialized or unavailable */
  }
}
